export default __webpack_public_path__ + "static/media/49.f9e83276.svg";